import {ValueCandidate, ValueSource} from './valueSource.types';

function filterBySearch(candidates: ValueCandidate[], search: string): ValueCandidate[] {
	const q = search.trim().toLowerCase();
	if (!q) {
		return candidates;
	}
	return candidates.filter(c => c.label.toLowerCase().includes(q));
}

export interface StaticValueSourceOptions {
	/** Resolve an id that is not in `candidates` to the id itself instead of leaving it unresolved.
	 *
	 * Use it when the candidate list is the source's COMPLETE vocabulary, so an unknown id can only
	 * be a stale or foreign value rather than one this source has yet to load. Echoing it makes the
	 * summary show what is actually stored; leaving it unresolved instead collapses the whole
	 * condition to "N selected", which tells the user strictly less and hides the bad value.
	 *
	 * Leave it off when an id can be legitimate but simply unknown to this source. */
	echoUnknownIds?: boolean;
}

export function createStaticValueSource(candidates: ValueCandidate[], opts?: StaticValueSourceOptions): ValueSource {
	const byId = Object.fromEntries(candidates.map(c => [c.id, c.label]));
	return {
		useCandidates(search: string) {
			return {items: filterBySearch(candidates, search), loading: false};
		},
		resolveLabels(ids: string[]) {
			const out: Record<string, string> = {};
			ids.forEach(id => {
				if (byId[id] !== undefined) {
					out[id] = byId[id];
				} else if (opts?.echoUnknownIds) {
					out[id] = id;
				}
			});
			return out;
		},
	};
}
